import api from '@/services/Api';
import Reiseart from '@/types/Reiseart';
import { successSwal } from '@/helper/swals';
import { ActionContext, Module } from 'vuex';
import { AxiosResponse } from 'axios';
import { ReiseartenState, RootState } from '@/store/types';

export type ReiseartenFilter = { gueltig: string };
export type LoadReiseartenPayload = { filter: ReiseartenFilter };
export type UpdateReiseartPayload = { reiseart: Reiseart; filter: ReiseartenFilter };
export type DeleteReiseartPayload = { reiseart: Reiseart; filter: ReiseartenFilter };

type Context = ActionContext<ReiseartenState, RootState>;

export const reisearten: Module<ReiseartenState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            reisearten: false,
        },
        reisearten: [],
    },
    actions: {
        loadReisearten({ commit }: Context, payload?: LoadReiseartenPayload): void {
            commit('setLoadersReisearten', true);
            commit('setReisearten', []);

            api.post('verwaltung/reisearten/load', payload)
                .then((response: AxiosResponse) => commit('setReisearten', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoadersReisearten', false));
        },
        updateReiseart({ commit, dispatch }: Context, { reiseart, filter }: UpdateReiseartPayload): void {
            commit('setLoadersSave', true);

            api.post('verwaltung/reisearten/speichern', reiseart)
                .then(() => {
                    successSwal('Reiseart', 'gespeichert');
                    dispatch('loadReisearten', { filter });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersSave', false));
        },
        deleteReiseart({ commit, dispatch }: Context, { reiseart, filter }: DeleteReiseartPayload): void {
            commit('setLoadersDelete', true);

            api.post('verwaltung/reisearten/loeschen', reiseart)
                .then(() => {
                    successSwal('Reiseart', 'gelöscht');
                    dispatch('loadReisearten', { filter });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersDelete', false));
        },
    },
    mutations: {
        setReisearten(state: ReiseartenState, payload: Partial<Reiseart>[]): void {
            state.reisearten = payload.map((data) => new Reiseart(data));
        },
        setDialogsDetail(state: ReiseartenState, visible: boolean): void {
            state.dialogs.edit = visible;
        },
        setLoadersSave(state: ReiseartenState, visible: boolean): void {
            state.loaders.save = visible;
        },
        setLoadersDelete(state: ReiseartenState, visible: boolean): void {
            state.loaders.delete = visible;
        },
        setLoadersReisearten(state: ReiseartenState, visible: boolean): void {
            state.loaders.reisearten = visible;
        },
    },
};
